import I18n from '@utils/i18n.utils';

export enum OrganisationType {
  CLIENT = 'CLIENT',
  SUPPLIER = 'SUPPLIER',
}

export namespace OrganisationType {
  export const selectItems = () => [
    {label: I18n.t('global.organisationType.SUPPLIER'), value: OrganisationType.SUPPLIER},
    {label: I18n.t('global.organisationType.CLIENT'), value: OrganisationType.CLIENT},
  ];
}


export enum OrganisationStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum OrganisationLanguage {
  ENGLISH = 'EN',
  ITALIAN = 'IT',
  GERMAN = 'DE',
  FRENCH = 'FR',
}

export namespace OrganisationLanguage {
  export const selectItems = () => [
    {label: I18n.t('global.organisationLanguage.english'), value: OrganisationLanguage.ENGLISH},
    {label: I18n.t('global.organisationLanguage.italian'), value: OrganisationLanguage.ITALIAN},
    {label: I18n.t('global.organisationLanguage.german'), value: OrganisationLanguage.GERMAN},
    {label: I18n.t('global.organisationLanguage.french'), value: OrganisationLanguage.FRENCH},
  ];
}

export enum ContactType {
  DEFAULT_INVOICING = 'DEFAULT_INVOICING',
  INVOICING_REMINDER = 'INVOICING_REMINDER',
  COMMERCIAL = 'COMMERCIAL',
  OPERATIONAL = 'OPERATIONAL',
  INTERNAL_COMMERCIAL = 'INTERNAL_COMMERCIAL',
  INTERNAL_OPERATIONAL = 'INTERNAL_OPERATIONAL',
  /* HAZARDOUSWASTE = 'HAZARDOUSWASTE',  */
  SAFETY = 'SAFETY',
  EXTERNAL_OPERATIONAL = 'EXTERNAL_OPERATIONAL',
  INTERNAL_ADMINISTRATIVE = 'INTERNAL_ADMINISTRATIVE',
  EXTERNAL_ADMINISTRATIVE = 'EXTERNAL_ADMINISTRATIVE',
  UNDEFINED = 'UNDEFINED'
}

export namespace ContactType {
  export const label = (type?: ContactType) => {
    switch (type) {
      case ContactType.INTERNAL_COMMERCIAL:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.internalCommercial').toLowerCase()}`;
      case ContactType.COMMERCIAL:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.commercial').toLowerCase()}`;
      case ContactType.DEFAULT_INVOICING:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.invoicing').toLowerCase()}`;
      case ContactType.INVOICING_REMINDER:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.invoicingReminder').toLowerCase()}`;
      case ContactType.OPERATIONAL:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.operational').toLowerCase()}`;
      case ContactType.INTERNAL_OPERATIONAL:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.internalOperational').toLowerCase()}`;
      case ContactType.SAFETY:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.safety').toLowerCase()}`;
      case ContactType.EXTERNAL_OPERATIONAL:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.externalOperational').toLowerCase()}`;
      case ContactType.INTERNAL_ADMINISTRATIVE:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.internalAdministrative').toLowerCase()}`;
      case ContactType.EXTERNAL_ADMINISTRATIVE:
        return `${I18n.t('unitDetails.contacts.drawerTitle')} ${I18n.t('global.contactType.externalAdministrative').toLowerCase()}`;
      default:
        return type;
    }
  };
  export const selectItems = () => [
    {label: I18n.t('global.contactType.internalCommercial'), value: ContactType.INTERNAL_COMMERCIAL},
    {label: I18n.t('global.contactType.commercial'), value: ContactType.COMMERCIAL},
    {label: I18n.t('global.contactType.invoicing'), value: ContactType.DEFAULT_INVOICING},
    {label: I18n.t('global.contactType.invoicingReminder'), value: ContactType.INVOICING_REMINDER},
    {label: I18n.t('global.contactType.operational'), value: ContactType.OPERATIONAL},
    {label: I18n.t('global.contactType.internalOperational'), value: ContactType.INTERNAL_OPERATIONAL},
    {label: I18n.t('global.contactType.safety'), value: ContactType.SAFETY},
    {label: I18n.t('global.contactType.externalOperational'), value: ContactType.EXTERNAL_OPERATIONAL},
    {label: I18n.t('global.contactType.internalAdministrative'), value: ContactType.INTERNAL_ADMINISTRATIVE},
    {label: I18n.t('global.contactType.externalAdministrative'), value: ContactType.EXTERNAL_ADMINISTRATIVE}
  ];
}

export enum Currency {
  EUR = 'EUR',
  CHF = 'CHF',
}

export namespace Currency {
  export const selectItems = () => [
    {label: Currency.EUR, value: Currency.EUR},
    {label: Currency.CHF, value: Currency.CHF},
  ];
}

export enum TaxRule {
  RS = 'RS',
  RE = 'RE',
  STI = 'STI',
  ICO = 'ICO',
  RX = 'RX',
  RC = 'RC',
  RR = 'RR',
  IPS2 = 'IPS2',
  PGR2 = 'PGR2',
}

export namespace TaxRule {
  export const selectItems = () => [
    {label: I18n.t('global.taxRule.RS'), value: TaxRule.RS},
    {label: I18n.t('global.taxRule.RE'), value: TaxRule.RE},
    {label: I18n.t('global.taxRule.STI'), value: TaxRule.STI},
    {label: I18n.t('global.taxRule.ICO'), value: TaxRule.ICO},
    {label: I18n.t('global.taxRule.RX'), value: TaxRule.RX},
    {label: I18n.t('global.taxRule.RC'), value: TaxRule.RC},
    {label: I18n.t('global.taxRule.RR'), value: TaxRule.RR},
    {label: I18n.t('global.taxRule.IPS2'), value: TaxRule.IPS2},
    {label: I18n.t('global.taxRule.PGR2'), value: TaxRule.PGR2},
  ];
}

export enum PaymentTerm {
  PAYBVR_N = 'PAYBVR_N',
  CBN30 = 'CBN30',
  CBN60 = 'CBN60',
  CBN90 = 'CBN90',
  CBN120 = 'CBN120',
  CBN180 = 'CBN180',
  CQN30 = 'CQN30',
  CQN60 = 'CQN60',
  CQN90 = 'CQN90',
  CQN120 = 'CQN120',
  CQN180 = 'CQN180',
  CIN30 = 'CIN30',
  CIN60 = 'CIN60',
  CIN90 = 'CIN90',
  CIN120 = 'CIN120',
  CIN180 = 'CIN180',
  FBN0 = 'FBN0',
  FBN10 = 'FBN10',
  FBN15 = 'FBN15',
  FBN30 = 'FBN30',
  FBN45 = 'FBN45',
  FBN60 = 'FBN60',
  FBN90 = 'FBN90',
  FIN0 = 'FIN0',
  FIN10 = 'FIN10',
  FIN15 = 'FIN15',
  FIN30 = 'FIN30',
  FIN45 = 'FIN45',
  FIN60 = 'FIN60',
  FIN90 = 'FIN90',
  FQN0 = 'FQN0',
  FQN10 = 'FQN10',
  FQN15 = 'FQN15',
  FQN30 = 'FQN30',
  FQN45 = 'FQN45',
  FQN60 = 'FQN60',
  FQN90 = 'FQN90',
  FRM30 = 'FRM30',
}

export namespace PaymentTerm {

  export const isQr = (paymentTerm: PaymentTerm): boolean => {
    return [PaymentTerm.FQN0, PaymentTerm.FQN10, PaymentTerm.FQN15, PaymentTerm.FQN30, PaymentTerm.FQN45, PaymentTerm.FQN60, PaymentTerm.FQN90].includes(paymentTerm);
  };


  export const selectItems = () => [
    {label: I18n.t('global.paymentTerm.PAYBVR_N'), value: PaymentTerm.PAYBVR_N},
    {label: I18n.t('global.paymentTerm.CBN30'), value: PaymentTerm.CBN30},
    {label: I18n.t('global.paymentTerm.CBN60'), value: PaymentTerm.CBN60},
    {label: I18n.t('global.paymentTerm.CBN90'), value: PaymentTerm.CBN90},
    {label: I18n.t('global.paymentTerm.CBN120'), value: PaymentTerm.CBN120},
    {label: I18n.t('global.paymentTerm.CBN180'), value: PaymentTerm.CBN180},
    {label: I18n.t('global.paymentTerm.CQN30'), value: PaymentTerm.CQN30},
    {label: I18n.t('global.paymentTerm.CQN60'), value: PaymentTerm.CQN60},
    {label: I18n.t('global.paymentTerm.CQN90'), value: PaymentTerm.CQN90},
    {label: I18n.t('global.paymentTerm.CQN120'), value: PaymentTerm.CQN120},
    {label: I18n.t('global.paymentTerm.CQN180'), value: PaymentTerm.CQN180},
    {label: I18n.t('global.paymentTerm.CIN30'), value: PaymentTerm.CIN30},
    {label: I18n.t('global.paymentTerm.CIN60'), value: PaymentTerm.CIN60},
    {label: I18n.t('global.paymentTerm.CIN90'), value: PaymentTerm.CIN90},
    {label: I18n.t('global.paymentTerm.CIN120'), value: PaymentTerm.CIN120},
    {label: I18n.t('global.paymentTerm.CIN180'), value: PaymentTerm.CIN180},
    {label: I18n.t('global.paymentTerm.FBN0'), value: PaymentTerm.FBN0},
    {label: I18n.t('global.paymentTerm.FBN10'), value: PaymentTerm.FBN10},
    {label: I18n.t('global.paymentTerm.FBN15'), value: PaymentTerm.FBN15},
    {label: I18n.t('global.paymentTerm.FBN30'), value: PaymentTerm.FBN30},
    {label: I18n.t('global.paymentTerm.FBN45'), value: PaymentTerm.FBN45},
    {label: I18n.t('global.paymentTerm.FBN60'), value: PaymentTerm.FBN60},
    {label: I18n.t('global.paymentTerm.FBN90'), value: PaymentTerm.FBN90},
    {label: I18n.t('global.paymentTerm.FIN0'), value: PaymentTerm.FIN0},
    {label: I18n.t('global.paymentTerm.FIN10'), value: PaymentTerm.FIN10},
    {label: I18n.t('global.paymentTerm.FIN15'), value: PaymentTerm.FIN15},
    {label: I18n.t('global.paymentTerm.FIN30'), value: PaymentTerm.FIN30},
    {label: I18n.t('global.paymentTerm.FIN45'), value: PaymentTerm.FIN45},
    {label: I18n.t('global.paymentTerm.FIN60'), value: PaymentTerm.FIN60},
    {label: I18n.t('global.paymentTerm.FIN90'), value: PaymentTerm.FIN90},
    {label: I18n.t('global.paymentTerm.FQN0'), value: PaymentTerm.FQN0},
    {label: I18n.t('global.paymentTerm.FQN10'), value: PaymentTerm.FQN10},
    {label: I18n.t('global.paymentTerm.FQN15'), value: PaymentTerm.FQN15},
    {label: I18n.t('global.paymentTerm.FQN30'), value: PaymentTerm.FQN30},
    {label: I18n.t('global.paymentTerm.FQN45'), value: PaymentTerm.FQN45},
    {label: I18n.t('global.paymentTerm.FQN60'), value: PaymentTerm.FQN60},
    {label: I18n.t('global.paymentTerm.FQN90'), value: PaymentTerm.FQN90},
    {label: I18n.t('global.paymentTerm.FRM30'), value: PaymentTerm.FRM30},
  ];
}

export enum OrganisationKind {
  RETAIL = 'RETAIL',
  INDUSTRIES = 'INDUSTRIES',
  CONSTRUCTION = 'CONSTRUCTION',
  SMB = 'SMB',
  MATERIAL_SUPPLIER = 'MATERIAL_SUPPLIER',
  TRANSPORT = 'TRANSPORT',
  RECYCLING = 'RECYCLING',
  VALORISATION = 'VALORISATION',
}

export namespace OrganisationKind {
  export const selectItems = () => [
    {label: I18n.t('global.organisationKind.retail'), value: OrganisationKind.RETAIL},
    {label: I18n.t('global.organisationKind.industries'), value: OrganisationKind.INDUSTRIES},
    {label: I18n.t('global.organisationKind.construction'), value: OrganisationKind.CONSTRUCTION},
    {label: I18n.t('global.organisationKind.smb'), value: OrganisationKind.SMB},
    {label: I18n.t('global.organisationKind.materialSupplier'), value: OrganisationKind.MATERIAL_SUPPLIER},
    {label: I18n.t('global.organisationKind.transport'), value: OrganisationKind.TRANSPORT},
    {label: I18n.t('global.organisationKind.recycling'), value: OrganisationKind.RECYCLING},
    {label: I18n.t('global.organisationKind.valorisation'), value: OrganisationKind.VALORISATION},
  ].sort((a, b) => a.label.localeCompare(b.label));
}

export enum Domain {
  BTP = 'BTP',
  BTP_ARCHITECT = 'BTP_ARCHITECT',
  BTP_DEMOLITION = 'BTP_DEMOLITION',
  BTP_2ND_WORK = 'BTP_2ND_WORK',
  BTP_2ND_WORK_FLOOR = 'BTP_2ND_WORK_FLOOR',
  BTP_2ND_WORK_PAINT = 'BTP_2ND_WORK_PAINT',
  BTP_2ND_WORK_CARPENTRY = 'BTP_2ND_WORK_CARPENTRY',
  BTP_2ND_WORK_ELEC = 'BTP_2ND_WORK_ELEC',
  BTP_2ND_WORK_IRON = 'BTP_2ND_WORK_IRON',
  BTP_2ND_WORK_PLUMBER = 'BTP_2ND_WORK_PLUMBER',
  BTP_2ND_WORK_AIR_COND = 'BTP_2ND_WORK_AIR_COND',
  BTP_2ND_WORK_HEATING = 'BTP_2ND_WORK_HEATING',
  BTP_2ND_WORK_ROOF_COVER = 'BTP_2ND_WORK_ROOF_COVER',
  BTP_2ND_WORK_CIVIL = 'BTP_2ND_WORK_CIVIL',
  BTP_EARTHWORK = 'BTP_EARTHWORK',
  BTP_GENERAL = 'BTP_GENERAL',
  ADMINISTRATION_COLLECTIVITY = 'ADMINISTRATION_COLLECTIVITY',
  ADMINISTRATION_COLLECTIVITY_COMMUNAL = 'ADMINISTRATION_COLLECTIVITY_COMMUNAL',
  ADMINISTRATION_COLLECTIVITY_TOWNSHIP = 'ADMINISTRATION_COLLECTIVITY_TOWNSHIP',
  ADMINISTRATION_COLLECTIVITY_ASSO = 'ADMINISTRATION_COLLECTIVITY_ASSO',
  ADMINISTRATION_COLLECTIVITY_CONFEDERATE = 'ADMINISTRATION_COLLECTIVITY_CONFEDERATE',
  SHOP = 'SHOP',
  SHOP_SUPERMARKET = 'SHOP_SUPERMARKET',
  SHOP_SMALL_RETAIL = 'SHOP_SMALL_RETAIL',
  SHOP_WHOLESALE = 'SHOP_WHOLESALE',
  SHOP_MECHANIC_CAR = 'SHOP_MECHANIC_CAR',
  SHOP_BIG_RETAIL = 'SHOP_BIG_RETAIL',
  SCHOOL = 'SCHOOL',
  SCHOOL_PUBLIC = 'SCHOOL_PUBLIC',
  SCHOOL_UNIVERSITY = 'SCHOOL_UNIVERSITY',
  SCHOOL_PRIVATE = 'SCHOOL_PRIVATE',
  SCHOOL_SPORT_CLUB = 'SCHOOL_SPORT_CLUB',
  EVENT = 'EVENT',
  EVENT_SOCIETY = 'EVENT_SOCIETY',
  EVENT_CONGRESS = 'EVENT_CONGRESS',
  EVENT_PROTEST_FESTIVAL = 'EVENT_PROTEST_FESTIVAL',
  EVENT_SPORT = 'EVENT_SPORT',
  TRAIN_AIRPORT = 'TRAINSTATION_AIRPORT',
  TRAIN_AIRPORT_TRAINSTRATION = 'TRAIN_AIRPORT_TRAINSTRATION',
  TRAIN_AIRPORT_AIRPORT = 'TRAIN_AIRPORT_AIRPORT',
  HOTEL_RESTAURANT = 'HOTEL_RESTAURANT',
  HOTEL_RESTAURANT_LEISURE = 'HOTEL_RESTAURANT_LEISURE',
  HOTEL_RESTAURANT_HOTEL = 'HOTEL_RESTAURANT_HOTEL',
  HOTEL_RESTAURANT_RESTAURANT = 'HOTEL_RESTAURANT_RESTAURANT',
  INDUSTRY = 'INDUSTRY',
  INDUSTRY_FOOD = 'INDUSTRY_FOOD',
  INDUSTRY_CHEMICAL = 'INDUSTRY_CHEMICAL',
  INDUSTRY_LUXURY = 'INDUSTRY_LUXURY',
  INDUSTRY_PHARMA = 'INDUSTRY_PHARMA',
  INDUSTRY_MECH_ELEC = 'INDUSTRY_MECH_ELEC',
  INDUSTRY_PRINTING = 'INDUSTRY_PRINTING',
  HEALTH_SOCIAL = 'HEALTH_SOCIAL',
  HEALTH_SOCIAL_EMS = 'HEALTH_SOCIAL_EMS',
  HEALTH_SOCIAL_HOSPITAL = 'HEALTH_SOCIAL_HOSPITAL',
  HEALTH_SOCIAL_LABO = 'HEALTH_SOCIAL_LABO',
  HEALTH_SOCIAL_MEDICAL = 'HEALTH_SOCIAL_MEDICAL',
  HEALTH_SOCIAL_CLINICAL = 'HEALTH_SOCIAL_CLINICAL',
  PRIMARY_SECTOR = 'PRIMARY_SECTOR',
  PRIMARY_SECTOR_AGRI = 'PRIMARY_SECTOR_AGRI',
  PRIMARY_LANDSCAPING = 'PRIMARY_LANDSCAPING',
  SERVICES = 'SERVICES',
  SERVICES_FACILITY_MANAGER = 'SERVICES_FACILITY_MANAGER',
  SERVICES_CLEANING = 'SERVICES_CLEANING',
  TERTIARY = 'TERTIARY',
  TERTIARY_PROPERTY_MANAGEMENT = 'TERTIARY_PROPERTY_MANAGEMENT',
  TERTIARY_ONG = 'TERTIARY_ONG',
  TERTIARY_PUBLIC = 'TERTIARY_PUBLIC',
  TERTIARY_BANK = 'TERTIARY_BANK',
  TERTIARY_FOUNDATION = 'TERTIARY_FOUNDATION',
  CARRIER = 'CARRIER',
  CARRIER_LOGISTIC = 'CARRIER_LOGISTIC',
  CARRIER_RELOCATION = 'CARRIER_RELOCATION',
  WASTE_JOBS = 'WASTE_JOBS',
  WASTE_JOBS_CARRIER = 'WASTE_JOBS_CARRIER',
  WASTE_JOBS_DESTINATION = 'WASTE_JOBS_DESTINATION',
  INDIVIDUAL = 'INDIVIDUAL',
  OIL_COMPANY = 'OIL_COMPANY',
  OIL_COMPANY_DISTRIBUTOR = 'OIL_COMPANY_DISTRIBUTOR',
  OIL_COMPANY_PRODUCER = 'OIL_COMPANY_PRODUCER',
}

export namespace Domain {
  export const selectItems = () => [
    {label: I18n.t('global.domain.btp'), value: Domain.BTP},
    {label: I18n.t('global.domain.btpArchitec'), value: Domain.BTP_ARCHITECT},
    {label: I18n.t('global.domain.btpDemolition'), value: Domain.BTP_DEMOLITION},
    {label: I18n.t('global.domain.btp2ndWork'), value: Domain.BTP_2ND_WORK},
    {label: I18n.t('global.domain.btp2ndWorkFloor'), value: Domain.BTP_2ND_WORK_FLOOR},
    {label: I18n.t('global.domain.btp2ndWorkPaint'), value: Domain.BTP_2ND_WORK_PAINT},
    {label: I18n.t('global.domain.btp2ndWorkCarpentry'), value: Domain.BTP_2ND_WORK_CARPENTRY},
    {label: I18n.t('global.domain.btp2ndWorkElec'), value: Domain.BTP_2ND_WORK_ELEC},
    {label: I18n.t('global.domain.btp2ndWorkIron'), value: Domain.BTP_2ND_WORK_IRON},
    {label: I18n.t('global.domain.btp2ndWorkPlumber'), value: Domain.BTP_2ND_WORK_PLUMBER},
    {label: I18n.t('global.domain.btp2ndWorkAirCond'), value: Domain.BTP_2ND_WORK_AIR_COND},
    {label: I18n.t('global.domain.btp2ndWorkHeating'), value: Domain.BTP_2ND_WORK_HEATING},
    {label: I18n.t('global.domain.btp2ndWorkRoofCover'), value: Domain.BTP_2ND_WORK_ROOF_COVER},
    {label: I18n.t('global.domain.btp2ndWorkCivil'), value: Domain.BTP_2ND_WORK_CIVIL},
    {label: I18n.t('global.domain.btpEarthwork'), value: Domain.BTP_EARTHWORK},
    {label: I18n.t('global.domain.btpGeneral'), value: Domain.BTP_GENERAL},
    {label: I18n.t('global.domain.administrationCollectivity'), value: Domain.ADMINISTRATION_COLLECTIVITY},
    {
      label: I18n.t('global.domain.administrationCollectivityCommunal'),
      value: Domain.ADMINISTRATION_COLLECTIVITY_COMMUNAL
    },
    {
      label: I18n.t('global.domain.administrationCollectivityTownship'),
      value: Domain.ADMINISTRATION_COLLECTIVITY_TOWNSHIP
    },
    {label: I18n.t('global.domain.administrationCollectivityAsso'), value: Domain.ADMINISTRATION_COLLECTIVITY_ASSO},
    {
      label: I18n.t('global.domain.administrationCollectivityConfederate'),
      value: Domain.ADMINISTRATION_COLLECTIVITY_CONFEDERATE
    },
    {label: I18n.t('global.domain.shop'), value: Domain.SHOP},
    {label: I18n.t('global.domain.shopSupermarket'), value: Domain.SHOP_SUPERMARKET},
    {label: I18n.t('global.domain.shopSmallRetail'), value: Domain.SHOP_SMALL_RETAIL},
    {label: I18n.t('global.domain.shopWholesale'), value: Domain.SHOP_WHOLESALE},
    {label: I18n.t('global.domain.shopMechanicCar'), value: Domain.SHOP_MECHANIC_CAR},
    {label: I18n.t('global.domain.shopBigRetail'), value: Domain.SHOP_BIG_RETAIL},
    {label: I18n.t('global.domain.school'), value: Domain.SCHOOL},
    {label: I18n.t('global.domain.schoolPublic'), value: Domain.SCHOOL_PUBLIC},
    {label: I18n.t('global.domain.schoolUniversity'), value: Domain.SCHOOL_UNIVERSITY},
    {label: I18n.t('global.domain.schoolPrivate'), value: Domain.SCHOOL_PRIVATE},
    {label: I18n.t('global.domain.schoolSportClub'), value: Domain.SCHOOL_SPORT_CLUB},
    {label: I18n.t('global.domain.event'), value: Domain.EVENT},
    {label: I18n.t('global.domain.eventSociety'), value: Domain.EVENT_SOCIETY},
    {label: I18n.t('global.domain.eventCongress'), value: Domain.EVENT_CONGRESS},
    {label: I18n.t('global.domain.eventProtestFestival'), value: Domain.EVENT_PROTEST_FESTIVAL},
    {label: I18n.t('global.domain.eventSport'), value: Domain.EVENT_SPORT},
    {label: I18n.t('global.domain.trainAirport'), value: Domain.TRAIN_AIRPORT},
    {label: I18n.t('global.domain.trainAirportTrainstration'), value: Domain.TRAIN_AIRPORT_TRAINSTRATION},
    {label: I18n.t('global.domain.trainAirportAirport'), value: Domain.TRAIN_AIRPORT_AIRPORT},
    {label: I18n.t('global.domain.hotelRestaurant'), value: Domain.HOTEL_RESTAURANT},
    {label: I18n.t('global.domain.hotelRestaurantLeisure'), value: Domain.HOTEL_RESTAURANT_LEISURE},
    {label: I18n.t('global.domain.hotelRestaurantHotel'), value: Domain.HOTEL_RESTAURANT_HOTEL},
    {label: I18n.t('global.domain.hotelRestaurantRestaurant'), value: Domain.HOTEL_RESTAURANT_RESTAURANT},
    {label: I18n.t('global.domain.industry'), value: Domain.INDUSTRY},
    {label: I18n.t('global.domain.industryFood'), value: Domain.INDUSTRY_FOOD},
    {label: I18n.t('global.domain.industryChemical'), value: Domain.INDUSTRY_CHEMICAL},
    {label: I18n.t('global.domain.industryLuxury'), value: Domain.INDUSTRY_LUXURY},
    {label: I18n.t('global.domain.industryPharma'), value: Domain.INDUSTRY_PHARMA},
    {label: I18n.t('global.domain.industryMechElec'), value: Domain.INDUSTRY_MECH_ELEC},
    {label: I18n.t('global.domain.industryPrinting'), value: Domain.INDUSTRY_PRINTING},
    {label: I18n.t('global.domain.healthSocial'), value: Domain.HEALTH_SOCIAL},
    {label: I18n.t('global.domain.healthSocialEms'), value: Domain.HEALTH_SOCIAL_EMS},
    {label: I18n.t('global.domain.healthSocialHospital'), value: Domain.HEALTH_SOCIAL_HOSPITAL},
    {label: I18n.t('global.domain.healthSocialLabo'), value: Domain.HEALTH_SOCIAL_LABO},
    {label: I18n.t('global.domain.healthSocialMedical'), value: Domain.HEALTH_SOCIAL_MEDICAL},
    {label: I18n.t('global.domain.healthSocialClinical'), value: Domain.HEALTH_SOCIAL_CLINICAL},
    {label: I18n.t('global.domain.primarySector'), value: Domain.PRIMARY_SECTOR},
    {label: I18n.t('global.domain.primarySectorAgri'), value: Domain.PRIMARY_SECTOR_AGRI},
    {label: I18n.t('global.domain.primaryLandscaping'), value: Domain.PRIMARY_LANDSCAPING},
    {label: I18n.t('global.domain.services'), value: Domain.SERVICES},
    {label: I18n.t('global.domain.servicesFacilityManager'), value: Domain.SERVICES_FACILITY_MANAGER},
    {label: I18n.t('global.domain.servicesCleaning'), value: Domain.SERVICES_CLEANING},
    {label: I18n.t('global.domain.tertiary'), value: Domain.TERTIARY},
    {label: I18n.t('global.domain.tertiaryPropertyManagement'), value: Domain.TERTIARY_PROPERTY_MANAGEMENT},
    {label: I18n.t('global.domain.tertiaryOng'), value: Domain.TERTIARY_ONG},
    {label: I18n.t('global.domain.tertiaryPublic'), value: Domain.TERTIARY_PUBLIC},
    {label: I18n.t('global.domain.tertiaryBank'), value: Domain.TERTIARY_BANK},
    {label: I18n.t('global.domain.tertiaryFoundation'), value: Domain.TERTIARY_FOUNDATION},
    {label: I18n.t('global.domain.carrier'), value: Domain.CARRIER},
    {label: I18n.t('global.domain.carrierLogistic'), value: Domain.CARRIER_LOGISTIC},
    {label: I18n.t('global.domain.carrierRelocation'), value: Domain.CARRIER_RELOCATION},
    {label: I18n.t('global.domain.wasteJobs'), value: Domain.WASTE_JOBS},
    {label: I18n.t('global.domain.wasteJobsCarrier'), value: Domain.WASTE_JOBS_CARRIER},
    {label: I18n.t('global.domain.wasteJobsDestination'), value: Domain.WASTE_JOBS_DESTINATION},
    {label: I18n.t('global.domain.individual'), value: Domain.INDIVIDUAL},
    {label: I18n.t('global.domain.oilCompany'), value: Domain.OIL_COMPANY},
    {label: I18n.t('global.domain.oilCompanyDistributor'), value: Domain.OIL_COMPANY_DISTRIBUTOR},
    {label: I18n.t('global.domain.oilCompanyProducer'), value: Domain.OIL_COMPANY_PRODUCER}
  ].sort((a, b) => a.label.localeCompare(b.label));
}

export enum ClientOrganisationActiveStat {
  INCINERABLE_PERCENTAGE_POSITION = 'INCINERABLE_PERCENTAGE_POSITION',
}

export namespace ClientOrganisationActiveStat {
  export const selectItems = () => [
    {
      label: I18n.t('global.clientOrganisationActiveStat.incinerablePercentagePosition'),
      value: ClientOrganisationActiveStat.INCINERABLE_PERCENTAGE_POSITION
    },
  ].sort((a, b) => a.label.localeCompare(b.label));
}
